/* Read an explicitly kept Private Edit; no browsing profile or storage writes. */
(() => {
  'use strict';
  if (window.SMEditContinuityReady) return;
  window.SMEditContinuityReady = true;
  const prefix = 'sm_private_edit_kept:';
  const bindings = new Map();
  // These are the four authored codes in page.your-select-profile.json.
  // Keep this allowlist in sync if the House replaces its curated edit codes.
  const codes = new Set(['collection', 'signature', 'motion', 'twinfit']);
  const choices = {
    purpose: ['everyday', 'travel', 'gift', 'occasion'],
    scope: ['one', 'full-look', 'accessory', 'guide'],
    silhouette: ['clean', 'relaxed', 'statement'],
    palette: ['monochrome', 'neutral', 'graphic', 'palette-guide'],
    fit: ['known', 'fit-atelier'],
  };
  const validate = value => {
    if (!value || value.version !== 2 || typeof value.code !== 'string' || !codes.has(value.code) ||
        !value.answers || typeof value.answers !== 'object' || Array.isArray(value.answers) ||
        !Object.entries(choices).every(([key, options]) => options.includes(value.answers[key])) ||
        !Array.isArray(value.handles) || !value.handles.length || value.handles.length > 3 ||
        value.handles.some(handle => typeof handle !== 'string' || !/^[a-z0-9][a-z0-9-]{0,127}$/.test(handle)) ||
        new Set(value.handles).size !== value.handles.length ||
        (['one', 'accessory'].includes(value.answers.scope) && value.handles.length > 1)) return null;
    return value;
  };
  const read = key => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw && raw.length <= 2000 ? validate(JSON.parse(raw)) : null;
    } catch (_) { return null; }
  };
  const reset = entry => {
    if (entry.product) entry.root.hidden = true;
    else {
      entry.link.textContent = entry.label;
      if (entry.copy) { entry.copy.textContent = entry.description; entry.copy.hidden = entry.descriptionHidden; }
    }
    delete entry.root.dataset.smEditBound;
  };
  const refresh = key => {
    const entries = bindings.get(key);
    if (!entries) return;
    const saved = window.Shopify?.designMode ? null : read(key);
    entries.forEach(entry => {
      if (!entry.root.isConnected) { reset(entry); entries.delete(entry); return; }
      if (entry.product) {
        entry.root.hidden = !saved || !saved.handles.includes(entry.product);
      } else {
        entry.link.textContent = saved ? 'Return to your edit' : entry.label;
        if (entry.copy) {
          entry.copy.textContent = saved ? 'Your kept edit stays in this browser.' : entry.description;
          entry.copy.hidden = saved ? false : entry.descriptionHidden;
        }
      }
    });
    if (!entries.size) bindings.delete(key);
  };
  const initialise = scope => {
    const targets = [...scope.querySelectorAll('[data-sm-edit-continuity]')];
    if (scope.matches?.('[data-sm-edit-continuity]')) targets.unshift(scope);
    const changed = new Set();
    targets.forEach(root => {
      if (root.dataset.smEditBound === 'true') return;
      const link = root.querySelector('[data-sm-edit-continuity-link]');
      if (!link) return;
      let destination, configured;
      try {
        destination = new URL(link.href, window.location.href);
        configured = new URL(root.dataset.smEditPath, window.location.origin);
      } catch (_) { return; }
      if (destination.origin !== window.location.origin || configured.origin !== window.location.origin || destination.pathname !== configured.pathname) return;
      const product = root.dataset.smEditProduct;
      if (product !== undefined && !/^[a-z0-9][a-z0-9-]{0,127}$/.test(product)) return;
      const copy = root.querySelector('[data-sm-edit-continuity-copy]');
      const key = prefix + destination.pathname;
      const entry = {root, link, copy, product, label: link.textContent, description: copy?.textContent || '', descriptionHidden: Boolean(copy?.hidden)};
      if (!bindings.has(key)) bindings.set(key, new Set());
      bindings.get(key).add(entry);
      root.dataset.smEditBound = 'true';
      changed.add(key);
    });
    changed.forEach(refresh);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), {once: true});
  else initialise(document);
  window.addEventListener('sm:private-edit-changed', event => {
    if (typeof event.detail?.path === 'string') refresh(prefix + event.detail.path);
  });
  window.addEventListener('storage', event => {
    if (event.key === null) bindings.forEach((_, key) => refresh(key));
    else if (bindings.has(event.key)) refresh(event.key);
  });
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    bindings.forEach((entries, key) => {
      entries.forEach(entry => {
        if (event.target.contains(entry.root)) { reset(entry); entries.delete(entry); }
      });
      if (!entries.size) bindings.delete(key);
    });
  });
})();
